/** In-app signal when server consent sync fails (R8 / §8). */

const CONSENT_SYNC_FAILED_EVENT = 'customer:consent:sync-failed';

export function notifyConsentSyncFailed(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(CONSENT_SYNC_FAILED_EVENT));
}

export function subscribeConsentSyncFailed(handler: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }
  window.addEventListener(CONSENT_SYNC_FAILED_EVENT, handler);
  return () => {
    window.removeEventListener(CONSENT_SYNC_FAILED_EVENT, handler);
  };
}
